import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { EnvService } from './app/services/env.service';
import { TenantInfoService } from './app/services/tenant-info.service';

if (environment.production) {
  enableProdMode();
}

/**
 * Bootstrap the application.
 *
 * Order is important:
 * 1. Load version.txt first so EnvService.ambienteHeader resolves correctly
 *    (needed for SUP environment where header = sup_{version}).
 * 2. Then prefetch tenant info before Angular bootstraps, so MSAL config
 *    factories can read it synchronously from sessionStorage (they run
 *    before APP_INITIALIZER).
 * 3. Finally bootstrap Angular.
 */
fetch('assets/version.txt')
  .then(r => r.text())
  .then(text => {
    const regex = /(?:\D*?)(\d)(?:\D*?)(\d)(?:\D*?)(\d)/g;
    const matches = regex.exec(text);
    if (matches) {
      EnvService.version = `V.${matches[1]}.${matches[2]}${matches[3]}`;
    }

    EnvService.interfaceVersion = text;
  })
  .catch(() => { /* localhost / no version.txt: ok to fail */ })
  .then(() => TenantInfoService.prefetch())
  .then(() => platformBrowserDynamic().bootstrapModule(AppModule))
  .catch(err => console.error(err));
